export default "__VITE_ASSET__3c4415a1__"